import { FormError } from '@monorepo/tools/src/lib/models/form-error.model';

export function getUniqueFormErrorMessages(errors: Map<string, FormError>): string[] {
	const messages: string[] = [];
	const seen = new Set<string>();

	errors.forEach(error => {
		const msg = error.getMsg()?.trim();
		if (msg && !seen.has(msg)) {
			seen.add(msg);
			messages.push(msg);
		}
	});

	return messages;
}

export function formatFormErrorToast(messages: string[]): string {
	if (messages.length === 0) {
		return 'Please complete all mandatory fields';
	}

	return messages.join(' • ');
}

export function extractAskErrorMessage(error: unknown, fallback: string): string {
	if (!error || typeof error !== 'object') {
		return fallback;
	}

	const data = 'data' in error ? (error as { data?: unknown }).data : undefined;
	if (!data || typeof data !== 'object') {
		return fallback;
	}

	const message = 'message' in data ? (data as { message?: unknown }).message : undefined;
	if (typeof message === 'string' && message.trim()) {
		return message.trim();
	}

	if (message && typeof message === 'object' && 'message' in message) {
		const nested = (message as { message?: unknown }).message;
		if (typeof nested === 'string' && nested.trim()) {
			return nested.trim();
		}
	}

	return fallback;
}
